import { useState } from "react";
import { useParams } from "react-router-dom";

export function useMedicalRecordNavigation(localSteps: any[]) {
  const [currentStep, setCurrentStep] = useState(0);
  const [currentSubStep, setCurrentSubStep] = useState(0);
  const [prevStep, setPrevStep] = useState();

  const { type } = useParams();

  const currentStepData = localSteps[currentStep];
  const currentSubStepData =
    currentStepData?.InverseParentSteps?.[currentSubStep];
  const stepsCount = localSteps?.length ?? 0;
  const subCount = currentStepData?.InverseParentSteps?.length ?? 0;

  const isLastStep =
    currentStep === stepsCount - 1 &&
    (subCount === 0 || currentSubStep === subCount - 1);

  const resetSteps = () => {
    setCurrentStep(0);
    setCurrentSubStep(0);
  };

  const isCustomizeMode = type === "customize";
  const isViewMode = type === "details";
  const isUpdateRecordMode = type === "update";

  const stepFieldIds =
    currentStepData?.StepFields?.map((f: any) => `step-field-${f.Id}`) || [];
  const subStepFieldIds =
    currentSubStepData?.StepFields?.map((f: any) => `substep-field-${f.Id}`) ||
    [];

  return {
    currentStep,
    currentSubStep,
    prevStep,
    setCurrentStep,
    setCurrentSubStep,
    setPrevStep,
    currentStepData,
    currentSubStepData,
    isLastStep,
    resetSteps,
    isCustomizeMode,
    isViewMode,
    isUpdateRecordMode,
    stepFieldIds,
    subStepFieldIds,
  };
}
